export interface IUser {
  id: number
  username: string
  email: string
  groups: IUserGroups[]
  firstName?: string
  lastName?: string
}

export interface IUserGroups {
  id: number
  name: string
}

export enum enRules {
  Tech = "Tech",
  ReplenishmentReplenisher = "Replenishment Replenisher",
  ReplenishmentDashboardView = "Replenishment Dashboard View",
  ReplenishmentBalanceView = "Replenishment Balance View",
  ReplenishmentStockoutView = "Replenishment Stockout View",
  ReplenishmentReplenishmentsView = "Replenishment Replenishments View",
  ReplenishmentConfigsView = "Replenishment Configs View",
  ReplenishmentConfigsBatchesView = "Replenishment Configs Batches View",
}

export const permissionsAplication = {
  [enRules.Tech]: "Tecnologia",
  [enRules.ReplenishmentReplenisher]: "Abastecedor",
  [enRules.ReplenishmentDashboardView]: "Visualizador do Dashboard",
  [enRules.ReplenishmentBalanceView]: "Visualizador de balanço dos itens",
  [enRules.ReplenishmentStockoutView]: "Visualizador de itens sem estoque",
  [enRules.ReplenishmentReplenishmentsView]: "Visualizador de itens abastecidos",
  [enRules.ReplenishmentConfigsView]: "Visualizador de configurações",
  [enRules.ReplenishmentConfigsBatchesView]: "Visualizador de configurações de lotes",
}

export const routeConfig = {
  painelRules: [
    enRules.Tech,
    enRules.ReplenishmentDashboardView,
    enRules.ReplenishmentBalanceView,
    enRules.ReplenishmentStockoutView,
    enRules.ReplenishmentReplenishmentsView,
    enRules.ReplenishmentConfigsView,
  ],
}
